import BvBadge, { type BvBadgeArgs } from 'volta/components/bv-badge';
import BvIcon from 'volta/components/bv-icon';
import BvInline from 'volta/components/bv-inline';
import BvTooltip from 'volta/components/bv-tooltip';
import orElse from 'volta/helpers/or-else';

import type { TOC } from '@ember/component/template-only';
import type { AnyFunction } from 'global';
import type { THueVariationString } from 'volta/utils/style-utils';

export interface AlertIconSignature {
  Args: {
    color?: THueVariationString;
    disabled?: boolean;
    onClick?: AnyFunction;
    primaryIcon?: string;
    secondaryIcon?: string;
    secondaryIconColor?: THueVariationString;
    size?: BvBadgeArgs['size'];
    subtle?: boolean;
    tooltip?: string;
    tooltipSubtext?: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const AlertIconComponent: TOC<AlertIconSignature> = <template>
  {{#let (orElse @size 'sm') as |size|}}
    <BvBadge
      class='alert-icon'
      @onClick={{@onClick}}
      @color={{@color}}
      @size={{size}}
      @disabled={{@disabled}}
      @subtle={{@subtle}}
      ...attributes
    >
      <BvInline @gap='1' @blockAlign='center' @wrap={{false}}>
        <BvIcon
          @glyph={{@primaryIcon}}
          @color={{@color}}
          @size={{size}}
          class='alert-icon__primary'
        />
        {{#if @secondaryIcon}}
          <BvIcon
            @glyph={{@secondaryIcon}}
            @color={{orElse @secondaryIconColor @color}}
            @size='sm'
            class='alert-icon__secondary'
          />
        {{/if}}
        {{yield}}
      </BvInline>
      {{#if @tooltip}}
        <BvTooltip @text={{@tooltip}} @subtext={{@tooltipSubtext}} />
      {{/if}}
    </BvBadge>
  {{/let}}
</template>;

export default AlertIconComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    AlertIcon: typeof AlertIconComponent;
    'alert-icon': typeof AlertIconComponent;
  }
}
